<template>
    <app-content class="h-panel">
      <!-- 标题栏 -->
      <div class="h-panel-bar">
        <span class="h-panel-title">审计数据导出</span>
      </div>
  
      <div class="export-container">
        <!-- 顶部栏：年度选择 + 导出按钮 -->
        <div class="top-bar">
          <div class="top-left">
            <Select :datas="checkDataLists" v-model="params.start" :deletable="false" class="year-select"/>
            <div class="btn-export-btn">
              <vxe-button status="primary" @click="handleExportAuditData" :loading="loading" class="export-btn">
                导出审计数据
              </vxe-button>
            </div>
          </div>
          <div class="standard-tip">
            <i class="icon-info"></i>
            符合 GB/T 24589.1—2024《财经信息技术 会计核算软件数据接口 第1部分：企业》标准
          </div>
        </div>
  
        <!-- 合规导出说明栏 -->
        <div class="compliance-tip">
          <div class="tip-icon">🛡️</div>
          <div class="tip-content">
            <div class="tip-title">国家标准合规导出</div>
            <div class="tip-desc">
              导出的 ZIP 压缩包内含多个标准格式文件（XML 或 JSON），可直接提交税务机关或第三方审计系统，符合 GB/T 24589.1—2024 最新数据接口规范
            </div>
          </div>
        </div>
  
        <!-- 导出内容说明卡片组 -->
        <div class="section-title">
          <span class="title-icon">☷</span>
          导出内容说明
        </div>
        <div class="card-grid">
          <!-- 公共档案 -->
          <div class="info-card">
            <div class="card-icon folder-icon"></div>
            <div class="card-content">
              <div class="card-title">公共档案</div>
              <div class="card-desc">电子账簿、会计期间、凭证字类型、币种、部门、员工、供应商、客户档案</div>
              <div class="card-code">U01</div>
            </div>
          </div>
  
          <!-- 总账数据 -->
          <div class="info-card">
            <div class="card-icon book-icon"></div>
            <div class="card-content">
              <div class="card-title">总账数据</div>
              <div class="card-desc">会计科目、科目余额及发生额、记账凭证分录、现金流量数据</div>
              <div class="card-code">U02</div>
            </div>
          </div>
  
          <!-- 固定资产 -->
          <div class="info-card">
            <div class="card-icon asset-icon"></div>
            <div class="card-content">
              <div class="card-title">固定资产</div>
              <div class="card-desc">资产卡片、折旧记录、资产类别及变动情况（已启用时导出）</div>
              <div class="card-code">U04</div>
            </div>
          </div>
  
          <!-- 员工薪酬 -->
          <div class="info-card">
            <div class="card-icon salary-icon"></div>
            <div class="card-content">
              <div class="card-title">员工薪酬</div>
              <div class="card-desc">薪酬期间、薪酬项目、员工薪酬记录及明细（已启用时导出）</div>
              <div class="card-code">U05</div>
            </div>
          </div>
        </div>
  
        <!-- 使用说明 -->
        <div class="usage-card">
          <div class="usage-header">
            <span class="usage-icon">❓</span>
            <span class="usage-title">使用说明</span>
          </div>
          <ul class="usage-list">
            <li>导出文件为 ZIP 格式，XML 格式符合标准 Schema 规范</li>
            <li>固定资产和员工薪酬数据仅在对应模块已启用时才会导出</li>
            <li>导出的数据可直接用于税务审计</li>
          </ul>
        </div>
      </div>
    </app-content>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import setting from "@/api/setting";

  export default {
    name: "AuditDataExport",
    data() {
      return {
        checkDataLists: [],
        params: {
          start: null,
          accountStandard: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState(['currentAccountSets']),
    },
    methods: {
      getUniqueYearsInRange(startDateStr, endDateStr) {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        
        let uniqueYears = [];
        for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
          uniqueYears.push(year);
        }
        let uniqueYearsObj = [];
        uniqueYears.forEach(item => {
          let obj = { "key": `${item}`, "title": item + "年" }
          uniqueYearsObj.push(obj);
        })
        
        this.checkDataLists = uniqueYearsObj || [];
        if (this.checkDataLists.length > 0) {
          this.params.start = this.checkDataLists[this.checkDataLists.length - 1].key;
        }
      },

      handleExportAuditData() {
        if (!this.params.start) {
            this.$message.warning("请选择导出年度");
            return;
        }

        this.loading = true; // 开启加载

        const params = {
            accountSetsId: this.currentAccountSets.id,
            year: this.params.start,
            format: "xml"
        };

        setting.auditDataExport.get(params).then(blob => {
            // 下载文件
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            
            // 从响应头获取文件名（如果后端返回了）
            const contentDisposition = blob.type === 'application/zip' 
            ? `审计数据_${this.currentAccountSets.companyName}_${params.year}.zip`
            : 'audit-data.zip';
            
            link.download = contentDisposition;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.$message.success("导出成功");
        }).catch(err => {
            this.$message.error("导出失败，请稍后重试");
            console.error("导出异常", err);
        }).finally(() => {
            this.loading = false; // 关闭加载
        });
      }

    },
    created() {
      this.getUniqueYearsInRange(this.currentAccountSets.enableDate, this.currentAccountSets.currentAccountDate);
    }
  };
  </script>
  
  <style scoped>

  /* 基础容器 */
  .export-container {
    padding: 16px;
  }
  
  /* 顶部栏 */
  .top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .top-left {
    display: flex;
    align-items: center;
  }
  .btn-export-btn{
    margin-left: 10px;
  }
  .year-select {
    width: 120px;
  }
  .export-btn {
    background: #2f80ed;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
  }
  .standard-tip {
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  /* 合规说明栏 */
  .compliance-tip {
    background: #e8f3ff;
    border-radius: 6px;
    padding: 16px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
  }
  .tip-icon {
    font-size: 20px;
    color: #2f80ed;
  }
  .tip-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f80ed;
    margin-bottom: 4px;
  }
  .tip-desc {
    font-size: 13px;
    color: #444;
    line-height: 1.5;
  }
  
  /* 模块标题 */
  .section-title {
    font-size: 15px;
    font-weight: 600;
    margin: 20px 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .title-icon {
    font-size: 16px;
  }
  
  /* 卡片网格 */
  .card-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
  }
  .info-card {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #fff;
  }
  .card-icon {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .folder-icon {
    background: #e6f7ff;
    color: #1890ff;
  }
  .book-icon {
    background: #e6ffed;
    color: #52c41a;
  }
  .asset-icon {
    background: #fff7e6;
    color: #fa8c16;
  }
  .salary-icon {
    background: #fff0f6;
    color: #eb2f96;
  }
  .card-content {
    flex: 1;
  }
  .card-title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .card-desc {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    margin-bottom: 6px;
  }
  .card-code {
    font-size: 12px;
    color: #2f80ed;
    background: #e8f3ff;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
  }
  
  /* 使用说明卡片 */
  .usage-card {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    background: #fff;
  }
  .usage-header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .usage-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .usage-list li {
    font-size: 13px;
    color: #444;
    line-height: 1.6;
    margin-bottom: 6px;
  }
  .usage-list li:last-child {
    margin-bottom: 0;
  }
  
  /* 适配小屏幕 */
  @media (max-width: 768px) {
    .card-grid {
      grid-template-columns: 1fr;
    }
    .top-bar {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  
</style>